import React from "react";
import "./Footer.scss";
const Footer = (props) => {
    const { footNotes } = props;

    return (
        <div className="footer" data-testid="footer" >
            <div className="footer-note">{footNotes}</div>
        </div>
    )
}
export default Footer;
